import BulkAccessoryEditModal from './BulkAccessoryEditModal';

export default BulkAccessoryEditModal;
